import { FilledType } from 'data/types'
import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

const SECONDS_IN_DAY = 24 * 60 * 60

export const getFilledTrades = (days = 90, limit = 50) => {
  const cutoff = Date.now() - SECONDS_IN_DAY * days * 1000

  return fetchApi<{ orders: Array<FilledType> }>({
    auth: true,
    body: {
      limit
    },
    method: 'POST',
    url: getApiUrl('nabu-gateway/fills/history')
  }).then((result) => {
    if (!result.ok) {
      return result
    }

    return {
      ...result,
      response: {
        ...result.response,
        orders: result.response.orders.filter((entry) => entry.transactionTime > cutoff)
      }
    }
  })
}
